import { graphql } from 'react-relay/hooks'
import { useMutation } from 'hooks'
import { ConnectionHandler } from 'react-relay'

const mutation = graphql`
  mutation useReportTemplateCreateMutation($input: CreateReportTemplateInput!) {
    createReportTemplate(input: $input) {
      reportTemplate {
        rowId
        id
        name
        config
        organization {
          id
        }
      }
    }
  }
`

const updater = (store, { createReportTemplate }) => {
  const payload = store.getRootField('createReportTemplate')
  const newReportTemplate = payload.getLinkedRecord('reportTemplate')
  const organization = store.get(createReportTemplate.reportTemplate.organization.id)

  const templatesTableConnection = ConnectionHandler.getConnection(
    organization,
    'TemplatesTable_reportTemplates',
    {
      orderBy: 'CREATED_AT_DESC',
    },
  )

  const modalConnection = ConnectionHandler.getConnection(
    organization,
    'SelectTemplateModalHeader_reportTemplates',
    {
      orderBy: 'CREATED_AT_DESC',
    },
  )

  const connections = [templatesTableConnection, modalConnection]

  connections.filter(Boolean).forEach((connection) => {
    const newEdge = ConnectionHandler.createEdge(
      store,
      connection,
      newReportTemplate,
      'ReportTemplateEdge',
    )
    ConnectionHandler.insertEdgeBefore(connection, newEdge)
  })
}

export default function useReportTemplateCreate() {
  return useMutation(mutation, 'createReportTemplate', { updater })
}
